<template>
  <div v-if="user && user.id">

    <div class="box">
      <div class="flex flex-wrap items-end justify-between border-b border-theme-200 light:border-theme-600 pb-2">
        <div class="flex flex-wrap items-center">
          <p class="text-3xl font-bold leading-none">{{ user.name }}</p>
          <div class="ml-2 leading-none border-l pl-2 border-white light:border-black">
            <p class="text-xs font-bold">Created at:</p>
            <p>
              {{ $moment(user.created_at).format(config.dateTimeFormats.display) }}
            </p>
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-orange text-xs text-black" @click="$router.push('/administration/user/edit/' + user.id)">
            <i class="fas fa-edit"></i>
            <span class="ml-1">Edit</span>
          </button>
          <button type="button" class="btn btn-red text-xs text-black ml-2" @click.stop="deleteUser(user.id)" v-if="user.id !== User.id">
            <i class="fe-trash"></i>
            Delete
          </button>
        </div>
      </div>

      <div class="leading-tight">
        <p class="font-bold text-xs mt-4">Name:</p>
        <p class="text-xl">
          {{ user.name }}
        </p>

        <p class="font-bold text-xs mt-4">Email:</p>
        <p class="text-xl">
          {{ user.email }}
        </p>

        <p class="font-bold text-xs mt-4">Role:</p>
        <p class="text-xl">
          {{ user.roles.map(r => r.name).join(',') }}
        </p>
      </div>

    </div>

  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      userID: this.$route.params.userID,
      user: {},
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
      User: 'user/user',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    deleteUser(userID) {
      this.$swal.fire({
        title: 'Delete user',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      })
        .then((result) => {
          if (result.value) {
            // send delete
            axios.delete('users/' + userID)
              .then(() => {
                this.$swal.fire('Delete successful', '', 'success')
                this.$router.push('/administration/user/list')
              })
          }
        })
    },
    get() {
      axios.get('users/' + this.userID)
        .then((response) => {
          this.user = Object.assign({}, response.data)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'User not found',
            type: 'warning',
          })
        })
    },
  }
}
</script>
